export const placeTypes = [
  "101커피컨테이너",
  "123막창",
  "135튀김집",
  "1도씨맥주",
  "24시뼈다귀탕",
  "24시전주콩나물국밥",
  "292짬떡",
  "33떡볶이",
  "39치킨호프",
  "3일국밥",
  "45년의정부부대찌개",
  "4번출구",
  "72420",
  "74떡뽀끼",
  "88매운떡볶이",
  "88콩나물국밥",
  "95도씨카페",
  "ABC커피",
  "BS치킨",
  "DDC치킨",
  "JVL부대찌개",
  "RHB치킨",
  "h-kitchen",
  "가공식품",
  "가리미김밥",
  "가야밀면",
  "갈매기먹짱",
  "갈매기브루잉",
  "갈비배달도시락스트릿테이블",
  "갈비탕",
  "감성낙곱새",
  "감성분식 청춘식당",
  "감성족발",
  "감자탕",
  "갓식빵",
  "갓신",
  "강가네손만두",
  "강화통통생고기",
  "개성진찹쌀순대",
  "갤러리카페",
  "게다",
  "게스트하우스",
  "게요리",
  "게이트나인",
  "경주빵",
  "고고즉석떡볶이",
  "고고켄터키",
  "고기깡패",
  "고기바보",
  "고기뷔페",
  "고기원칙",
  "고래사어묵",
  "곰탕",
  "곱창",
  "공방",
  "공연장",
  "과일",
  "관람",
  "국밥",
  "국수",
  "굴요리",
  "그리스음식",
  "기사식당",
  "기업",
  "기타",
  "기타숙박업",
  "김밥",
  "꽃집",
  "낙지요리",
  "냉면",
  "농공시설",
  "다방",
  "다이어트",
  "단란주점",
  "달떡",
  "달볶이",
  "달봉이치킨",
  "달빛감자",
  "달쫀",
  "닭갈비",
  "닭발",
  "닭발먹은새우",
  "닭발싸롱",
  "닭볶음탕",
  "닭요리",
  "닭장수후라이드",
  "대게나라",
  "대게요리",
  "대구근대골목단팥빵",
  "대구불노리왕막창",
  "대구안지랑막창",
  "대구형제막창",
  "덮밥",
  "도넛",
  "도시락",
  "도자기제조",
  "독립서점",
  "독일음식",
  "돈가스",
  "돼지고기구이",
  "두부요리",
  "딤섬",
  "떡",
  "떡볶이",
  "떡카페",
  "뜨개",
  "라면",
  "라이브카페",
  "마라탕",
  "마카롱",
  "막국수",
  "만년닭강정",
  "만두",
  "매운탕",
  "맥주",
  "멕시코",
  "문가네진국",
  "문래돼지불백",
  "문배동육칼",
  "문빵9",
  "문수산상황삼계탕",
  "문스갈비",
  "문어부인삼교비",
  "뮌헨1589",
  "미가옥",
  "미니크로아프레",
  "미성당납작만두",
  "미술교육",
  "미스터떡볶이",
  "미스터세븐",
  "미스터쫀득이",
  "미식가의구이",
  "미인닭발",
  "미친노가리",
  "미친양꼬치",
  "미향해장국",
  "민혁이네외국포차",
  "밀겨울",
  "밀크밥버거",
  "밀키트",
  "바(BAR)",
  "바나나테이블",
  "바나프레소",
  "바담코다리",
  "바닷가재요리",
  "바람부리명태찜",
  "바로그집",
  "바르바커피",
  "바른생활샌드위치",
  "바베큐와춤을",
  "바비큐BOX",
  "바사칸동네치킨",
  "바오밥나무과자점",
  "박물관",
  "반려동물미용",
  "반찬가게",
  "백반",
  "백숙",
  "베이글",
  "베이커리",
  "베트남음식",
  "보리밥",
  "복어요리",
  "복합문화공간",
  "부속시설",
  "북문로떡볶이",
  "북카페",
  "분식",
  "불닭",
  "불타는여고24시떡볶이",
  "뷔페",
  "브런치",
  "브런치카페",
  "블루보틀",
  "비빔밥",
  "빙수",
  "빵류제조",
  "사찰음식",
  "사철",
  "삼청동국수",
  "상무팥죽",
  "샌드위치",
  "생선구이",
  "생선회",
  "샤브샤브",
  "서오릉피자",
  "셀프빨래방",
  "소고기구이",
  "수산물가공",
  "순대",
  "술집",
  "슈",
  "슈퍼",
  "스마일명품찹쌀꽈배기",
  "스마일찹쌀꽈배기",
  "스터디카페",
  "스테이크",
  "스파게티",
  "스파게티스토리",
  "스페인음식",
  "스푼떡볶이",
  "시골한우시골돼지",
  "시장통",
  "식료품",
  "식물원",
  "식빵이맛있는집네모",
  "신가네매운떡볶이",
  "신가네정읍국밥",
  "신떡순신천할매떡볶이",
  "신라해장국",
  "신안왕소금구이",
  "신의주부대찌개",
  "심야오뎅",
  "쌈밥",
  "씨앗호떡부산떡볶이",
  "아경면선",
  "아귀찜",
  "아메리칸존슨",
  "아몬드치킨",
  "아부찌부대찌개",
  "아시아음식",
  "아우라치킨",
  "아이스크림",
  "아프리카커피초콜릿",
  "악녀떡볶이",
  "앙마떡뽀끼앤카페빅",
  "애견카페",
  "애국돼지",
  "애플김밥",
  "야식",
  "양갈비",
  "양꼬치",
  "양식",
  "양푼이막창",
  "예식장",
  "오니기리",
  "오뎅",
  "오락",
  "오리요리",
  "오므라이스",
  "오징어요리",
  "와인",
  "와플",
  "요리주점",
  "우동",
  "유흥주점",
  "육류",
  "음식점",
  "이북음식",
  "이자카야",
  "이탈리아음식",
  "이흥용과자점",
  "인근주민",
  "인도음식",
  "인정국물떡볶이",
  "일공공키친",
  "일구보쌈족발",
  "일도씨닭갈비",
  "일본식라면",
  "일석삼조버섯매운탕",
  "일식",
  "일식당",
  "일식튀김",
  "일점사",
  "일초닭발",
  "일품순두부",
  "임실49피자",
  "자매떡볶이",
  "자스민커피",
  "자연e김밥",
  "자연담은화로",
  "잘난치킨",
  "잡솨봐불막창",
  "장금수부대찌개",
  "장수남원추어탕",
  "장수본가해장국",
  "장수통닭",
  "장어",
  "전",
  "전복요리",
  "전통",
  "정육식당",
  "정육점",
  "조개요리",
  "족발",
  "족황상제",
  "종합도소매",
  "종합분식",
  "주꾸미요리",
  "주류",
  "주류제조",
  "주먹밥",
  "주방용품",
  "죽",
  "중식당",
  "찌개",
  "찐빵",
  "찜닭",
  "차",
  "채식",
  "천연화장품",
  "체험마을",
  "초밥",
  "초콜릿전문점",
  "추어탕",
  "치킨",
  "카레",
  "카페",
  "카페일루이스",
  "칼국수",
  "커피번",
  "케이크전문",
  "크레페",
  "키즈카페",
  "킹크랩요리",
  "태국음식",
  "터키음식",
  "테마카페",
  "테이크아웃커피",
  "토스트",
  "특급호텔레스토랑",
  "패밀리레스토랑",
  "펜션",
  "편의점",
  "포장마차",
  "푸드코트",
  "푸드트럭",
  "퓨전음식",
  "프랑스음식",
  "프랜차이즈본사",
  "플라워카페",
  "피자",
  "한방카페",
  "한식",
  "한식뷔페",
  "한정식",
  "핫도그",
  "해물",
  "해산물뷔페",
  "해장국",
  "햄버거",
  "향토음식",
  "호두과자",
  "호떡",
  "홍차전문점",
  "화덕고깃간",
  "후렌치후라이",
];
